import { BaseObjectCount } from './base-object-count';

export interface TreatmentsCount extends BaseObjectCount<string> {}
